<div class="workflow-editor" [ngClass]="{'with-overlay': saveActionStatus != STATUS_LOADING && saveActionStatus != STATUS_DONE}">
  <ng-container *ngIf="pageStatus == STATUS_DONE else editorloading">
    <div class="box_fieldset" >
      <core-helpers-forms-button-white [text]="'Save'" [disabled]="!valid" (click)= "save()"></core-helpers-forms-button-white>
      <core-helpers-forms-button [type]="'grey'" [text]="'Cancel'" (click)="cancel()"></core-helpers-forms-button>
      
        <div [hidden]="!saving" class="workflow-editor-saving">
          <core-helpers-box-loading></core-helpers-box-loading>
        </div>
    </div>
    <div class="workflow-editor-wrapper">
      <figure id="workflow-editor-area"></figure>
    </div>
  </ng-container>
  
  <ng-template #editorloading>
    <div class="loader">
      <div class="dimmed">
        <div class="dimmed_title"></div>
        <div class="dimmed_flex">
          <div class="dimmed_box"></div>
        </div>
        <div class="dimmed_box_table">
        </div>
      </div>
    </div>
  </ng-template>
  <ng-container [ngSwitch]="saveActionStatus">
    <div class="workflow-editor-errors">
      <ng-template [ngSwitchCase]="STATUS_NOT_ALLOWED">
        <core-layout-modal-feedback
          [type]="'fail'"
          [message]="'Error'"
          [text]="'Oops! You are not allowed to save this workflow. We will show you the available workflows.'"
          [buttonText]="'OK'"
          (action)="showWorkflowsList($event)">
        </core-layout-modal-feedback>
      </ng-template>
      <ng-template [ngSwitchCase]="STATUS_NOT_FOUND">
        <core-layout-modal-feedback
          [type]="'warning'"
          [message]="'Workflow not saved'"
          [text]="'Oops! You are saving the wrong workflow. Reload the page to start again.'"
          [buttonText]="'OK'"
          (action)="dismiss($event)">
        </core-layout-modal-feedback>
      </ng-template>
      <ng-template [ngSwitchCase]="STATUS_ERROR">
        <core-layout-modal-feedback
          [type]="'fail'"
          [message]="'Error'"
          [text]="'There was an error saving your workflow data. Review your editor data and try again in a moment.'"
          [buttonText]="'OK'"
          (action)="dismiss($event)">
        </core-layout-modal-feedback>
      </ng-template>
      <ng-template [ngSwitchCase]="STATUS_DATA_ERROR">
        <core-layout-modal-feedback
          [type]="'warning'"
          [message]="'Workflow not saved'"
          [text]="'The data in the editor is not correct. Review your editor data and try again in a moment.'"
          [buttonText]="'OK'"
          (action)="dismiss($event)">
        </core-layout-modal-feedback>
      </ng-template>
      
    </div>
  </ng-container>
</div>
